import React from 'react';
import { useLocation } from 'react-router';
import { oneOf } from 'prop-types';
import VerifyNotif from '../VerifyNotif';
import VERIFICATION_TYPES from '../../types';
import OrganisationService from '../../../../services/organisation-service';
import { parseQueryString } from '../../../../util';
import AccountService from '../../../../services/account-service';
import style from './Verify.module.scss';

const Verify = ({ type }) => {
  const location = useLocation();
  let method = null;
  let params = null;
  if (type === VERIFICATION_TYPES.SENDER) {
    const { o, token } = parseQueryString(location.search);
    method = OrganisationService.verifySender;
    params = { ShortCode: o, token };
  } else if (type === VERIFICATION_TYPES.EMAIL) {
    const { email, token, pt } = parseQueryString(location.search);
    method = AccountService.verifyEmail;
    params = { email, token, passwordToken: pt };
  }

  return (
    <>
      {method ? (
        <div className={style.verify}>
          <div className={style.verifyPageFormContainer}>
            <VerifyNotif type={type} method={method} params={params} />
          </div>
        </div>
      ) : (
        <div className={style.center}>
          <p>Sorry, something went wrong!</p>
        </div>
      )}
    </>
  );
};

Verify.propTypes = {
  type: oneOf(Object.values(VERIFICATION_TYPES)).isRequired,
};

export default Verify;
